import React, { useCallback, useEffect } from "react";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { trackEvent } from "../../../services/applicationInsight";
import TrackNames from "../../../services/applicationInsight/trackers";
import { errorLog } from "../../../utils/debugLog";

/*
  Current possible Urls:
    - m360plus.es
    - app.msm.southpigalle.io
    - app.dev.msm.southpigalle.io
    - app.preprod.msm.southpigalle.io
*/

const AppUrlListener: React.FC<unknown> = () => {
  const handleAppOpener = useCallback((event: URLOpenListenerEvent) => {
    try {
      const parsedUrl = new URL(event.url);

      trackEvent(TrackNames.DeepLink, {
        externalUrl: event.url,
        ...parsedUrl,
      });

      if (parsedUrl.pathname) {
        window.location.href = parsedUrl.pathname + (parsedUrl.search || "");
      }
    } catch (err) {
      errorLog(err);
    }
  }, []);

  useEffect(() => {
    App.addListener("appUrlOpen", handleAppOpener);
    return () => {
      App.removeAllListeners();
    };
  }, [handleAppOpener]);

  return null;
};

export default AppUrlListener;
